import Vue from 'vue'
import App from './App.vue'
import router from './router' // 新增：引入路由配置
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 引入 Element UI 的样式文件
import request from '@/utils/request'
import { getDicts } from "@/api/system/dict/data"
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi"
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import DictData from '@/components/DictData'

Vue.prototype.getDicts = getDicts
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree

// 全局组件挂载
Vue.component('DictTag', DictTag)
DictData.install()
Vue.use(ElementUI) // 正确的方式是通过 Vue.use() 注册 ElementUI

Vue.config.productionTip = false

// 将api地址配置为全局变量. 通过this.$apiaddr访问
Vue.prototype.$apiaddr = 'Hello World';




request({
    url: '/api/home/getHomePageInfo',
    method: 'post',
  }).then(res => {
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if(flag){
        console.log('来源页面：', location.hash)
        const hash = location.hash
        if (hash.includes('PolicyDetail')||hash.includes('CompanyNewsDetail')||hash.includes('companyNewsDetail')) {
            // 判断政策
            const path = hash.replace(/^#\/?/, '')
            window.location.href =  res.data.websiteH5Url + path
        } else {
            window.location.href =  res.data.websiteH5Url
        }
	}
	Vue.prototype.$homePageInfo = res.data
	document.title = res.data.websiteName
	new Vue({
	  router, // 新增：挂载路由
	  render: h => h(App)
	}).$mount('#app')
  })


